import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import { TemplateExtended } from '@distribute/shared/api-types/templates';

import { useShareParams } from '../../../entities/share';
import { navigate } from '../../../processes/navigation';

import { usePreviewTemplate } from './use-preview-template';
import { templatesModel } from '../../../features/templates';

export const useShareTemplateHandler = (templates: TemplateExtended[]) => {
  const { params } = useShareParams();

  const distributeTemplates = useSelector(
    templatesModel.selectors.selectDistributeTemplates
  );

  const dispatch = useDispatch();

  const { pathname } = useLocation();

  const { handleTemplatePreview } = usePreviewTemplate();

  const templateToPreview = useMemo(() => {
    if (!params.id || !params.teamId) return null;

    const template = [...templates, ...distributeTemplates].find(
      (template) => template.id === Number(params.id)
    );

    return template ? { type: 'allow', data: template } : { type: 'forbidden' };
  }, [params, templates, distributeTemplates]);

  const isForbidden = templateToPreview?.type === 'forbidden';
  const isAllowed = templateToPreview?.type === 'allow';

  useEffect(() => {
    if (isAllowed && templateToPreview.data) {
      handleTemplatePreview(templateToPreview.data);
      dispatch(navigate({ to: pathname, isKeepQueryParams: false }));
    }
  }, [isAllowed, templateToPreview, handleTemplatePreview, pathname, dispatch]);

  return {
    isSharedDistributeTemplate: templateToPreview?.data?.isDistribute,
    isForbidden,
  };
};
